import { useQuery } from '@apollo/client';
import { useSelector } from 'src/store/react';
import { selectResultsJobIds, selectZone } from 'src/store/selectors';
import { useToggleSavedJob } from './utils/useToggleSavedJob';
import { GET_JOB_DETAILS_PERSONALISED } from 'src/modules/graphql/queries/jobDetails';
import { useSelectedLocale } from '../useSelectedLocale';

const noop = () => {};

interface Options {
  jobId: string;
  jobTracking?: string;
  solMetadataReference?: string;
  isJobDetailsView?: boolean;
}

export const useSaveJobJDV = ({
  jobId,
  jobTracking,
  solMetadataReference,
}: Options) => {
  const jobIds = useSelector(selectResultsJobIds);
  const locale = useSelectedLocale();
  const zone = useSelector(selectZone);

  const jobDetailsPersonalised = useQuery(GET_JOB_DETAILS_PERSONALISED, {
    variables: { id: jobId, locale, zone },
  });

  const { toggleSavedJob, isApplied, isSaved } = useToggleSavedJob({
    jobId,
    jobIds,
    view: 'jobDetails',
    linkPosition: 'job details',
    solMetadataReference,
    jobTracking,
    savedJobsData: jobDetailsPersonalised?.data,
  });

  return {
    isApplied,
    isSaved,
    toggleSavedJob: isApplied ? noop : toggleSavedJob,
  };
};
